/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const RecommendationsContext = createContext({
  fetchRecommendations: () => {}
})

export default RecommendationsContext
